import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CanceledOrderMiniEntity } from '../../domain/entities/CanceledOrderMiniEntity'

export class CanceledOrderMiniModel extends CanceledOrderMiniEntity {
  constructor(dataDto: CanceledOrderMiniEntity) {
    super()
    mapEntityProperties<CanceledOrderMiniEntity>(this, dataDto)
  }
}
